/**
 * @file 错误相关的 utils
 */
/**
 * 因为网络不稳定等原因, 基于 webpack 4 的应用下载 js/css 资源时可能会失败.
 * 该 util 用于判断该种类型的错误.
 *
 * @category Error Handling
 * @param error - 错误
 * @returns 是否
 */
export function isWebpack4ChunkLoadError(error) {
    var _a;
    return (
    // js
    (error === null || error === void 0 ? void 0 : error.name) === 'ChunkLoadError' ||
        (
        // css
        (_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.includes('Loading CSS chunk')));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZnVuY3Rpb25zL2Vycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUg7Ozs7Ozs7R0FPRztBQUNILE1BQU0sVUFBVSx3QkFBd0IsQ0FBQyxLQUFVOztJQUNqRCxPQUFPO0lBQ0wsS0FBSztJQUNMLENBQUEsS0FBSyxhQUFMLEtBQUssdUJBQUwsS0FBSyxDQUFFLElBQUksTUFBSyxnQkFBZ0I7O1FBQ2hDLE1BQU07UUFDTixNQUFBLEtBQUssYUFBTCxLQUFLLHVCQUFMLEtBQUssQ0FBRSxPQUFPLDBDQUFFLFFBQVEsQ0FBQyxtQkFBbUIsQ0FBQyxDQUFBLENBQzlDLENBQUE7QUFDSCxDQUFDIn0=